import React, { useState } from 'react';
import { motion } from 'framer-motion';
import BookModal from './BookModal';

const BookGrid = ({ books }) => {
  const [selectedBook, setSelectedBook] = useState(null);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        {books.map((book, index) => (
          <motion.div
            key={book.id}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: index * 0.05 }}
            className="bg-white dark:bg-navy-800 rounded-md overflow-hidden shadow-sm hover:shadow-md dark:shadow-navy-900 transition-shadow flex flex-col border border-stone-200 dark:border-navy-700 cursor-pointer group"
            onClick={() => setSelectedBook(book)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && setSelectedBook(book)}
            aria-label={`${book.title} von ${book.author} – Details anzeigen`}
          >
            <div className="aspect-[2/3] overflow-hidden bg-stone-100 dark:bg-navy-700 relative">
              <img
                src={book.cover}
                alt={book.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-brand/0 group-hover:bg-brand/30 transition-colors duration-300 flex items-center justify-center">
                <span className="text-white text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-brand/70 px-4 py-2 rounded-sm">
                  Mehr erfahren
                </span>
              </div>
            </div>
            <div className="p-5 flex-grow flex flex-col">
              <h3 className="text-lg font-serif font-bold text-stone-900 dark:text-stone-100 leading-tight mb-1 group-hover:text-amber-800 dark:group-hover:text-amber-400 transition-colors">
                {book.title}
              </h3>
              <p className="text-stone-600 dark:text-stone-400 text-sm mb-4">{book.author}</p>
              <div className="mt-auto flex justify-between items-center text-sm">
                <span className="text-stone-400 dark:text-stone-500">{book.year}</span>
                <span className="font-bold text-amber-800 dark:text-amber-400">{book.price}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <BookModal book={selectedBook} onClose={() => setSelectedBook(null)} />
    </>
  );
};

export default BookGrid;
